module.exports = __webpack_public_path__ + "img/54_2.f559b799.png";